import React from 'react'
import ReactDOM from 'react-dom'

import Registration from './Registration'

const el = document.getElementById('root');
ReactDOM.render(<Registration env={el.getAttribute('data-env')} devmode={el.getAttribute('data-devmode')} sitekey={el.getAttribute('data-sitekey')} stripepublickey={el.getAttribute('data-stripepublickey')} lookupKey={el.getAttribute('data-lookup-key')} preselectedValues={el.getAttribute('data-preselectedValues_json')} />, document.getElementById('root'))